import React from "react";
import { Certified } from "../Ads/certified";
import SliderFav from '../SliderFav';
import { CURRENCY } from '../../Config';
import Link from 'next/link';
import { dateFormat } from '../../helpers/dateHelper';
import icoCat from '@core/ui/static/images/ico-cat.svg';
import icoLocation from '@core/ui/static/images/ico-location.svg';
import icoCalendar from '@core/ui/static/images/ico-calendar.svg';
import { SEARCH_PAGE } from '@core/ui/navigation/constant';
import {
  DateWrapper,
  TitleWrapper,
  ImageWrapper,
  ActionWrapper,
} from './style';
import { useTranslation } from 'next-i18next';
import { slugify } from '../../helpers/urlHandler';
import { LabelTag, TagGroup } from '../TagGroup';
import NumberFormat from 'react-number-format';
import { truncateTitle } from '../../helpers/textHelpers';


const actions = {
  favorites: [],
};

const RenderAction = ({ actions }) => {
  const { t } = useTranslation();
  return (
    <>
      <ActionWrapper>
        {actions.map((action, i) => (
          <span key={i}>{action}</span>
        ))}
      </ActionWrapper>
    </>
  );
};

const RenderDate = ({ element }) => {
  const { t } = useTranslation();

  const { createdAt } = element;
  return (
    <>
      <DateWrapper>
        <span className="date">
          <img src={icoCalendar} alt={t('creationDate')} />{' '}
          {dateFormat(createdAt, t)}
        </span>
      </DateWrapper>
    </>
  );
};

const renderImage = ({ media, photos, sid, id }) => {
  return (
    <>
      <ImageWrapper className="slider">
        <SliderFav
          currency={CURRENCY}
          imageSrc={media}
          photos={photos}
          sid={sid}
          id={id}
        />
      </ImageWrapper>
    </>
  );
};

const RenderPrice = ({ element }) => {
  const { t } = useTranslation();
  const { price } = element;
  return (
    <>
      <NumberFormat
        value={price}
        displayType={'text'}
        thousandSeparator={' '}
        renderText={value => (
          <TagGroup>
            <LabelTag
              color="#00BCD4"
              tagContent={`${value} ${CURRENCY} `}
              style={{ fontSize: 13 }}
            />
          </TagGroup>
        )}
      />
    </>
  );
};

const RenderTitle = ({ element }) => {
  const { t } = useTranslation();

  const { sid, title, category, town, certified } = element;

  return (
    <>
      <TitleWrapper>
        <div className="title titleFav">
          <Certified certified={certified} size={20} style={{
            color: '#00BCD4',
            marginRight: 5,
          }} />
          <Link
            href={`/${SEARCH_PAGE}/${slugify(category)}/${slugify(
              title
            )}-${sid}`}
          >
            <span>
              <a>{truncateTitle(title)}</a>
            </span>
          </Link>
        </div>
        <div className="titleFav">
          <Link href={`/${SEARCH_PAGE}/${slugify(category)}`}>
            <span>
              <img src={icoCat} alt="icone cat" />
              <a>{category}</a>
            </span>
          </Link>
          <Link href={`/${SEARCH_PAGE}/all?town=${town.trim()}`}>
            <span className="localisation">
              <img src={icoLocation} alt="icone loc" />
              <a>{town}</a>
            </span>
          </Link>
        </div>
      </TitleWrapper>
    </>
  );
};

export { RenderAction, RenderDate, renderImage, RenderPrice, RenderTitle };
